import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';

import {
  getCreditCardPaymentReportAction,
  clearReportDataAction,
} from './state/actions';

import { Filter, Main } from 'Containers';
import CreditCardPaymentForm from './components/CreditCardPaymentForm';
import { ReportFieldEnum } from 'Common/FieldEnum';
import { ReportGeneration } from 'Common/ObjectHelper';
import { getUsersAction } from '../transactionhistory/state/actions';
import { CREDIT_CARD_PAYMENT_FORM_NAME } from 'Common/FormEnum';

class CreditCardPaymentReportContainer extends Component {
  componentDidMount() {
    this.props.getUsersAction();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.recordFetching && nextProps.report) {
      if (nextProps.report.length !== 0) {
        const { report } = nextProps;
        ReportGeneration(report, 'CreditCardPaymentReport');
        this.props.clearReportDataAction();
      }
    }
  }

  formSubmit = values => {
    const model = {
      User: values[ReportFieldEnum.User],
      SiteId: values[ReportFieldEnum.Site],
      FromDate: values[ReportFieldEnum.FromDate],
      ToDate: values[ReportFieldEnum.ToDate],
      GroupBy: values[ReportFieldEnum.GroupBy],
      SortBy: values[ReportFieldEnum.SortBy],
    };

    this.props.getCreditCardPaymentReportAction(model);
  };

  getMainProps = () => {
    const { recordFetching } = this.props;

    return {
      toolbox: {
        formName: CREDIT_CARD_PAYMENT_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          disabled: recordFetching,
          loading: recordFetching,
        },
        shown: true,
      },
    };
  };

  render() {
    return (
      <Fragment>
        <Filter title={'Credit Card Payment '} />
        <Main {...this.getMainProps()}>
          <CreditCardPaymentForm
            onSubmit={this.formSubmit}
            siteChange={this.siteChange}
            userLoad={this.props.userLoad}
            usersData={this.props.usersData}
            initialValues={{
              [ReportFieldEnum.GroupBy]: '1',
              [ReportFieldEnum.SortBy]: '1',
              [ReportFieldEnum.FromDate]: moment().format('MM/DD/YYYY'),
              [ReportFieldEnum.ToDate]: moment().format('MM/DD/YYYY'),
            }}
          />
        </Main>
      </Fragment>
    );
  }
}
const mapStateToProps = ({
  TransactionHistoryState,
  CreditCardPaymentState,
}) => {
  return {
    usersData: TransactionHistoryState.usersData,
    userLoad: TransactionHistoryState.userLoad,
    report: CreditCardPaymentState.reports,
    recordFetching: CreditCardPaymentState.reportLoading,
  };
};

export const CreditCardPayment = withRouter(
  connect(
    mapStateToProps,
    {
      getUsersAction,
      getCreditCardPaymentReportAction,
      clearReportDataAction,
    }
  )(CreditCardPaymentReportContainer)
);



// WEBPACK FOOTER //
// ./src/pages/creditcardpayment/CreditCardPayment.js